import './gallerymobile.less'

import {Carousel, useCarousel} from '@codeurs/carousel'
import React from 'react'
import {ImageType, WysiwygType} from 'types'
import {style} from 'util/style'
import {Carouselnav} from 'views/layout/carousel/carouselnav'
import {GalleryBackground, GalleryIframe, GalleryQuote} from './gallery'

const styles = style('gallerymobile')

export type GalleryMobileType = {
	images?: Array<ImageType>
	iframe?: string
	quote1?: WysiwygType
	quote2?: WysiwygType
}

export const GalleryMobile: React.FC<GalleryMobileType> = ({
	images,
	iframe,
	quote1,
	quote2
}) => {
	const carousel = useCarousel()

	return (
		<div className={styles()}>
			<div className={styles('images')}>
				<Carousel {...carousel}>
					{images.map((image, i) => (
						<div
							key={i}
							className={styles('images-image').is({
								active: carousel.isActive(i)
							})}
						>
							<GalleryBackground image={image} />
						</div>
					))}
				</Carousel>
				<Carouselnav carousel={carousel} className={styles('images-nav')} />
			</div>
			<div className={styles('quotes')}>
				<div className={styles('quotes-item')}>
					<GalleryQuote quote={quote1} />
				</div>
				<div className={styles('quotes-item')}>
					<GalleryQuote quote={quote2} />
				</div>
			</div>
			<div className={styles('iframe')}>
				<GalleryIframe iframe={iframe} />
			</div>
		</div>
	)
}
